import { Image } from "expo-image";
import React from "react";
import { Platform, StyleSheet, Text, View } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import { TEST_API } from "../../../utils/apiUrl";
import { timer_icon } from "../../../utils/images";
// import UserLevel from "../../Profile/childComponents/UserLevel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const ImageTextCard = ({ navigation, item, isHeaderBlock, url }) => {
  return (
    <View
      style={
        Platform.OS === "web" ? styles.text_card_blk_web : styles.text_card_blk
      }
    >
      <View style={styles.contentContainer}>
        <View style={styles.text_card_img_parent_header}>
          {item?.img1 && (
            <FastImage
              source={
                url === null || url === undefined
                  ? item?.img1
                  : { uri: item?.img1 }
              }
              style={styles.avatarStyle}
            />
          )}
        </View>
        <View style={styles.textContainer}>
          <Text style={styles.text_card_img_title}>{item.title}</Text>
          <Text style={[styles.text_card_img_subtitle, { marginTop: 4 }]}>{item.subtitle}</Text>
        </View>
      </View>
    </View>
  );
};

export default ImageTextCard;

const styles = StyleSheet.create({
  text_card_blk: {
    paddingVertical: 20,
    paddingHorizontal: 20,
    borderBottomColor: globalConfigurableData.primaryTextColor1,
    borderBottomWidth: 1,
  },
  text_card_blk_web: {
    paddingVertical: 20,
    paddingHorizontal: 20,
    borderBottomColor: globalConfigurableData.borderColor,
    borderBottomWidth: 1,
  },
  contentContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  textContainer: {
    marginLeft: 16,
    flex: 1,
    justifyContent: 'center',
  },
  text_card_img_title: {
    ...globalFontStyle.appFontSubHeading,
    color: globalConfigurableData.primaryTextColor1,
  },
  text_edit: {
    ...globalFontStyle.appFontSubHeading,
    color: GlobalScreens.Wallet.highlightColor,
  },
  text_card_img_subtitle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
  },
  text_card_img_parent_header: {
    width: 55,
    height: 55,
    borderRadius: 55,
    objectFit: "cover",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: GlobalScreens.Account.imgBgColor,
  },
  avatarStyle: {
    width: 55,
    height: 55,
    backgroundColor: GlobalScreens.Account.imgBgColor,
    borderRadius: 105,
  },
});
